export const ROUTES = {
  QUERYPARAMS: "/:instanceid?",
  HOME: "/",
  DASHBOARD: "/dashboard",
  ACCOUNT: "/account",
  APPS: "/apps",
  SECURITY: "/security",
  // Main navigation
  SURVEYS: "/surveys",
  SURVEY_CREATE: "/surveys/new",
  SURVEY_DETAIL: "/surveys/:id",
  SURVEY_EDIT: "/surveys/:id/edit",
  SURVEY_PREVIEW: "/surveys/:id/preview",
  SURVEY_RESULTS: "/surveys/results",
  SURVEY_RESULTS_DETAIL: "/surveys/results/:id",
  SURVEY_REQUESTS: "/surveys/requests",
  SURVEY_TEMPLATES: "/surveys/templates",
  PUBLIC_SURVEY: "/survey/:instanceId/:token",

  // Settings routes - Unique/Remaining
  PLATFORM: "/settings/session",
  // Skypoint staff: the instance's products, their history and the performance recompute (Task 18.b).
  INSTANCE_PRODUCTS: "/settings/products",

  // Auth & system routes
  ERRORPAGE: "/errorpage",
  CALLBACK: "/callback",

  // Merged Routes (New /clean paths)
  TENANTSETIINGS: "/tenants",
  CREATETENANT: "/createTenant",
  LOGS: "/logs",
  USERS: "/users",
  ROLES: "/roles",
  ACCESS_MANAGEMENT: "/settings/access-management",
  ROLE_MANAGEMENT: "/settings/role-management",
  CLIENTS_MANAGEMENT: "/settings/clients",
  GENERAL_SETTINGS: "/general-settings",
  // The tiled Settings page (2026-10-08 shell spec, D5): Hire's one Settings item opens it. The
  // settings pages keep their own routes; this page only links to them.
  SETTINGS_HUB: "/settings",
  // The tiled Templates page: Hire's one Templates item (Templates & Setup) opens it. Each template
  // page keeps its own route (/templates/email, /offers/templates, /surveys, ...); this page only
  // links to them. Matched exactly, so it never claims the /templates/* pages beneath it.
  TEMPLATES_HUB: "/templates",
  // Employee referral hub
  REFERRAL_HUB: "/referrals/overview",
  REFERRAL_OPEN_ROLES: "/referrals/open-roles",
  MY_REFERRALS: "/referrals/mine",
  REFERRAL_REWARDS: "/referrals/rewards",
  APPLICANTS: "/applicants",
  APPLICANT_DETAIL: "/applicants/:applicantId",
  CANDIDATE_INBOX: "/inbox",
  BULK_UPLOADS: "/bulk-uploads",
  JOBS: "/jobs",
  JOB_CREATE: "/jobs/new",
  JOB_DETAIL: "/jobs/:jobId",
  CRM_INTEGRATIONS: "/crm-integrations",
  JOB_PORTALS: "/job-portals",
  JOB_PORTAL_EDIT: "/job-portals/:portalId/edit",
  FORMS: "/forms",
  FORM_BUILDER: "/forms/:id/edit",
  TALENT_REDISCOVERY: "/talent-rediscovery",
  // Candidate documents in the customer's SharePoint. One candidate's folder is
  // /document-centre/:applicationId, on the same route entry.
  DOCUMENT_CENTRE: "/document-centre",
  SCHEDULED_TOURS: "/scheduled-tours",
  ONBOARD_PACKETS: "/onboard/packets",
  ONBOARD_TEMPLATES: "/onboard/templates",
  // skyAgent and skyBrain are two sections over one engine: skyAgent is where
  // work is done, skyBrain is what it knows. The catalog behind both lives in
  // src/views/skyagent/surfaces.ts — add a surface there, not just a route here.
  SKYAGENT: "/skyagent",
  SKYAGENT_AI_EMPLOYEES: "/skyagent/ai-employees",
  SKYAGENT_APPROVALS: "/skyagent/approvals",
  SKYAGENT_ARTIFACTS: "/skyagent/artifacts",
  SKYAGENT_CONFIGURATION: "/skyagent/configuration",
  SKYBRAIN: "/skybrain",
  SKYBRAIN_MEMORY: "/skybrain/memory",
  SKYBRAIN_SKILLS: "/skybrain/skills",
  SKYBRAIN_QUICK_PROMPTS: "/skybrain/quick-prompts",
  // Retired URLs, kept so existing links and bookmarks still land somewhere.
  // Each redirects to the surface that replaced it (appRoutes.ts) and is listed
  // on that surface's `legacyHrefs` so the route guard admits it.
  SKYAGENT_ADMIN: "/skyagent/admin",
  SKYAGENT_MEMORY: "/skyagent/memory",
  SKYAGENT_CAPABILITIES: "/skyagent/capabilities",
  SKYBRAIN_SESSION_HISTORY: "/skybrain/session-history",
  LOCATIONS: "/settings/locations",
  EMAIL_TEMPLATES: "/templates/email",
  SMS_TEMPLATES: "/templates/sms",
  EMAIL_SIGNATURE: "/settings/email-signature",
  SENDER_EMAILS: "/settings/sender-emails",
  FEEDBACK_TEMPLATES: "/templates/feedback",
  FEEDBACK_TEMPLATE_CREATE: "/templates/feedback/new",
  FEEDBACK_TEMPLATE_EDIT: "/templates/feedback/:id/edit",
  AI_INTERVIEW_TEMPLATES: "/templates/ai-interview",
  AI_INTERVIEW_TEMPLATE_CREATE: "/templates/ai-interview/new",
  AI_INTERVIEW_TEMPLATE_EDIT: "/templates/ai-interview/:id/edit",
  INTERVIEW_GUIDES: "/templates/interview-guides",
  INTERVIEW_GUIDE_CREATE: "/templates/interview-guides/new",
  INTERVIEW_GUIDE_EDIT: "/templates/interview-guides/:id/edit",
  FEEDBACK_SUBMISSION: "/applicants/:applicantId/feedback/:interviewId",
  PIPELINE_SETTINGS: "/settings/pipeline",
  AI_SCORING: "/settings/ai-scoring",
  ARCHIVE_REASONS_SETTINGS: "/settings/archive-reasons",
  CANDIDATE_ENGAGEMENT_SETTINGS: "/settings/candidate-engagement",
  CANDIDATE_ENGAGEMENT_RULES: "/settings/candidate-engagement/rules",
  CANDIDATE_PREFERENCES: "/candidate/preferences",
  INDEED_INTEGRATION: "/indeed-integration",
  LINKEDIN_INTEGRATION: "/linkedin-integration",
  HRIS_INTEGRATION: "/hris-integration",
  GREYTHR_INTEGRATION: "/greythr-integration",
  // The review before anything is sent to greytHR, for one hire. The instance id rides in the query.
  GREYTHR_REVIEW: "/greythr/review/:applicationId",
  /**
   * The same route without its parameter, for the sidebar allow-list only.
   *
   * The route guard matches a pathname against route BASES with a prefix test, so a pattern
   * carrying ":applicationId" can never match a real URL. Without this the page is not admitted,
   * and "Create greytHR profile" saves the hire and then bounces to the dashboard, which is
   * exactly what it did. The list routes get this for free because "/applicants" is a prefix of
   * "/applicants/:id"; this page has no list above it, so it needs its own base.
   */
  GREYTHR_REVIEW_BASE: "/greythr/review",
  CONNECTORS: "/connectors",
  RESUME_DIGEST: "/settings/resume-digest",
  JOB_POSTING_OPTIONS_SETTINGS: "/settings/job-posting",
  DEPARTMENTS_SETTINGS: "/settings/departments",
  JOB_TITLES_SETTINGS: "/settings/job-titles",
  REPORTS: "/reports",
  RESUME_TEMPLATES: "/settings/resume-templates",
  ANONYMIZATION_CONFIGS: "/settings/anonymization-configs",
  OFFERS: "/offers",
  OFFER_CREATE: "/offers/new",
  OFFER_DETAIL: "/offers/:offerId",
  OFFER_TEMPLATES: "/offers/templates",
  OFFER_TEMPLATE_EDIT: "/offers/templates/:id/edit",
  OFFER_WORKFLOWS: "/offers/workflows",
  OFFER_ANALYTICS: "/offers/analytics",
  OFFER_APPROVALS: "/offers/approvals",
  HELP_PLUS_SUPPORT: "/helpplussupport",
  CANDIDATE_CONTACT_INFO: "/settings/candidate-contact-info",
  // skyPerformance (spec §6). The active product is derived from this prefix (PRODUCT_LANDING_PATH).
  PERFORMANCE: "/performance",
  // skyPerformance IT (spec 2026-10-26 §3): its own subtree, PRODUCT_LANDING_PATH.skyperformance_it.
  PERFORMANCE_IT: "/it-performance",
  // E9: one Settings page, a tab per path segment. The Positions tab keeps its Phase 2 path;
  // PERFORMANCE_CONFIG is the Roles and wording tab (the old roles-and-wording path redirects).
  PERFORMANCE_SETTINGS: "/performance/settings",
  PERFORMANCE_SETTINGS_TAB: "/performance/settings/:tab",
  PERFORMANCE_POSITIONS: "/performance/settings/positions",
  PERFORMANCE_CONFIG: "/performance/settings/labels",
  // E1: the coaching log and one record (a page, deep-linkable: E1 spec D6).
  PERFORMANCE_COACHING: "/performance/coaching",
  PERFORMANCE_COACHING_RECORD: "/performance/coaching/records/:recordId",
  // E2: my own file, and someone else's by their (encoded) person key (D7, D12).
  PERFORMANCE_FILE: "/performance/file",
  PERFORMANCE_FILE_PERSON: "/performance/file/:personKey",
  // E6: the to-do list and its tabs (Assigned to me is the bare path; `?open=<id>` opens one).
  PERFORMANCE_TODOS: "/performance/todos",
  PERFORMANCE_TODOS_TAB: "/performance/todos/:tab",
  // Phase 3 placeholders: present so routeMapping's Record<NavId, …> compiles; no page is mounted on them yet and the paths are not decided.
  PERFORMANCE_PLANS: "/performance/plans",
  // E3: a tab of the list (`#/pips/t/<tab>`) and one plan; both under the Plans item's prefix.
  PERFORMANCE_PLANS_TAB: "/performance/plans/t/:tab",
  PERFORMANCE_PLAN: "/performance/plans/:planId",
  // E3.b R-A: the subject's own plan (`#/mypip`, views-pip.js:291-296), admitted under Home.
  PERFORMANCE_PLANS_MY: "/performance/plans/my",
  PERFORMANCE_EVALUATIONS: "/performance/evaluations",
  // E4: a tab of the list and one evaluation, under the Evaluations item's prefix; the subject's
  // own (completed) evaluation under Home, as E3.b R-A put the subject's own plan.
  PERFORMANCE_EVALUATIONS_TAB: "/performance/evaluations/t/:tab",
  PERFORMANCE_EVALUATION: "/performance/evaluations/:evaluationId",
  PERFORMANCE_EVALUATIONS_MY: "/performance/evaluations/my",
  PERFORMANCE_EVALUATION_MY: "/performance/evaluations/my/:evaluationId",
  // E4.b: the employee's own self-evaluation, under Home with their evaluation.
  PERFORMANCE_EVALUATION_MY_SELF: "/performance/evaluations/my/:evaluationId/self",
  PERFORMANCE_VISITS: "/performance/visits",
  // E5: a tab of the list and one visit, under the Visits item's prefix.
  PERFORMANCE_VISITS_TAB: "/performance/visits/t/:tab",
  PERFORMANCE_VISIT: "/performance/visits/:visitId",
  PERFORMANCE_ORG: "/performance/org",
  PERFORMANCE_RECORDS: "/performance/records",
  // E8: Records' Documents, Deleted and Exports and retention tabs, under the Records item's prefix.
  // A manager's and HR's /performance/documents opens the Documents tab (routeGuardRules).
  PERFORMANCE_RECORDS_TAB: "/performance/records/t/:tab",
  PERFORMANCE_DOCUMENTS: "/performance/documents",
  INSTRUMENTATIONKEYREACT: "c433df71-1d5b-4a1b-b68a-b0b95f53cd93",
} as const;

export const DocumentLink: Record<string, string> = {
  ":instanceid?": "/overview",
  "/": "/home",
  "/apps": "/overview",
  "/settings/session": "/tenant",
  "/security": "/security",
  "/privacycenter": "/privacycenter",
  "/editprivacycenter": "/editprivacycenter",
  "/datasubjectrequests": "/datasubjectrequest",
  "/datasubjectrequestcreate": "/datasubjectrequest",
  "/templates": "/privacytemplates",
  "/edittemplate": "/privacytemplates",
  "/reports": "/privacyreports",
  "/reportconsent": "/reports",
  "/errorpage": "/errorpage",
  "/callback": "/callback",
  "/skypointlogin": "/login",
  "/skypointsignup": "/signup",
  "/tabledata": "/tabledata",
  "/overlapdetails": "/overlapdetails",
  "/differentiatordetails": "/audiences",
  "/settings/instances": "/instance",
  "/settings/instanceDetails": "/instance",
  "/settings/instanceHistory": "/instance",
  "/settings/instanceBackup": "/instance",
  "/settings/tenants": "/tenant",
  "/transformations": "/transformations",
};

export const PREVIEWFIELDS = {
  date: new Date(Date.UTC(2012, 1, 20, 3, 0, 0)),
};
export const PREVIEWNUMBER = 456789.12;
export const PREVIEWPERCENTAGE = 12.8;

export const TIMEOUT_LOW = 10000;
export const TIMEOUT_MEDIUM = 20000;

export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const RESET = "RESET";

export const SUCCESS_MESSAGE = "successMessage";
export const ERROR_MESSAGE = "errorMessage";
export const SUCCESS_MESSAGE_BAR = "successMessageBar";
export const ERROR_MESSAGE_BAR = "errorMessageBar";
export const SUCCESS_MESSAGE_DASHBOARD = "successMessageDashboard";
export const ERROR_MESSAGE_DASHBOARD = "errorMessageDashboard";
export const WARNING_MESSAGE_DASHBOARD = "warningMessageDashboard";

export const BANKACCOUNTHOLDER = {
  INDIVIDUAL: "Individual",
  COMPANY: "Company",
} as const;

export const CONSTANTS = {
  tableLowerCase: "table",
  tableUpperCase: "Table",
  tablesLowerCase: "tables",
  tablesUpperCase: "Tables",
  database: "Database",
  databases: "Databases",
  tableName: "Table name",
} as const;

export const FILTER_OPTIONS = [
  "Contains",
  "Does not contain",
  "Start with",
  "Ends with",
  "Is null",
  "Is not null",
] as const;

export const INSTANCE_HISTORY_ACTION_TYPES = {
  Create: "Create",
  Edit: "Edit",
} as const;

export const INSTANCE_HISTORY_STATUS_TYPES = {
  Success: "Success",
  Failed: "Failed",
} as const;

export const COMMON_NOTIFICATION_MESSAGES = {
  errorMessage: "Something went wrong",
} as const;
